import { gql } from '@apollo/client'
import { SURVEY_LINK_CONFIG_FIELDS } from './fragments/surveyLinkConfig'

export const SAVE_SURVEY_RESPONSE = gql`
  ${SURVEY_LINK_CONFIG_FIELDS}
  mutation saveSurveyResponse(
    $surveyLinkId: ID!
    $questionKey: String!
    $answer: JSON!
    $warnBeforeStopping: Boolean
  ) {
    saveSurveyResponse(
      surveyLinkId: $surveyLinkId
      questionKey: $questionKey
      answer: $answer
      warnBeforeStopping: $warnBeforeStopping
    ) {
      id
      surveyLink {
        config {
          ...SurveyLinkConfig
        }
      }
    }
  }
`
